<template>
  <div class="my_slider_layer m-lr-11" @mousedown.stop>
    <span v-if="title" v-text="title" class="title slider-title" :style="{ width: titleWidth + 'px' }"></span>
    <p :class="type === 'one_level' ? 'set_one_level' : 'set_two_level'">
      <el-slider
        class="slider_style"
        style="width: 200px; margin-right: 8px"
        v-model="Result"
        :min="min"
        :max="max"
        :step="step"
        @change="change"
        :disabled="disabled"
        :show-tooltip="false"
      />
      <my_input_number
        titleWidth="0"
        class="slider-input"
        :value.sync="inputResult"
        :min="min"
        :max="max"
        size="small"
        :num-type="numType"
        :step="step"
        :symbol="symbol"
        width="56"
        :precision="precision"
        @change="change_input"
      />
    </p>
  </div>
</template>

<script>
import my_input_number from '../my_input_number'
export default {
  name: 'MySliderIndex',
  props: {
    titleWidth: {
      // 组件的标题
      type: String,
      default: '40'
    },
    title: {
      // 组件的标题
      type: String,
      default: ''
    },
    symbol: {
      type: String,
      default: 'px'
    },
    type: {
      // 组件的类型  one_level 一级组件 two_level 二级组件
      type: String,
      default: 'two_level'
    },
    value: {
      // 输入框的值
      type: [Number, String],
      default: 0
    },
    disabled: {
      type: Boolean,
      default: false
    },
    min: {
      // 输入框的值
      type: Number,
      default: 0
    },
    max: {
      // 输入框的值
      type: Number,
      default: 10000
    },
    step: {
      // 步长
      type: Number,
      default: 1
    },
    numType: {
      type: String,
      default: 'int'
    },
    precision: {
      type: Number,
      default: 0
    }
  },
  components: {
    my_input_number
  },
  data() {
    return {
      Result: this.value,
      inputResult: this.value,
      isShow: true
    }
  },
  watch: {
    Result(val) {
      this.inputResult = val
      this.$emit('update:value', val) // 双向数据绑定
      this.$emit('change', val)
    },
    value(val) {
      this.Result = this.value
    }
  },
  methods: {
    clickEvent(key, value) {
      this[key] = value
      if (!value) {
        this.$nextTick(() => {
          this.$refs.input_new.focus()
        })
      }
    },
    change(val) {
      // 抛出一个操作停止后的change事件
      this.$emit('handle_stop_change', val)
    },
    change_input(val) {
      this.Result = Number(val)
    }
  }
}
</script>

<style scoped type="text/css" lang="scss">
$theme-primary: #0086ff;

.my_slider_layer {
  .slider-title {
    display: block;
    font-size: 13px;
    color: #333;
  }

  .set_two_level {
    //padding-left: 6px;
  }

  ::v-deep .el-slider__button-wrapper {
    transform: translateX(-12px);
  }

  .set_one_level,
  .set_two_level {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  ::v-deep .el-slider {
    .el-slider__bar {
      background-color: $theme-primary;
    }

    .el-slider__button {
      border-color: $theme-primary;
      //background-color: $theme-primary;
      width: 14px;
      height: 14px;
    }
  }

  ::v-deep .my_input_number_layer {
    .set_two_level {
      margin-bottom: 0;
    }
  }

  .input_display {
    margin-left: 5px;
    font-size: 14px;
  }

  ::v-deep .edit_item_inline {
    margin-bottom: 0;
  }

  .slider-input {
    margin-bottom: 0;
  }

  ::v-deep .slider-input .el-input__inner {
    padding-left: 10px;
    padding-right: 10px;
  }
}

.slider-input {
  ::v-deep .my_title {
    display: none;
  }

  // ::v-deep .my-num-symbol {
  //   height: 24px;
  //   line-height: 24px;
  // }
  // ::v-deep {
  //   .el-input--small .el-input__inner {
  //     height: 24px;
  //     line-height: 24px;
  //     background-color: #EDEDED;
  //     border-color: #EDEDED;
  //   }
  //   .input-wrapper .my-num-symbol {
  //     top: 3px;
  //   }
  // }
}

.slider-input {
  ::v-deep .el-input-number.is-controls-right .el-input__inner {
    padding-left: 10px;
  }
}
</style>
